import _sm from "./screens/sm.mjs"
import _md from "./screens/md.mjs"
import _lg from "./screens/lg.mjs"
import _xl from "./screens/xl.mjs"
import _2xl from "./screens/2xl.mjs"
const config = { "sm": _sm, "md": _md, "lg": _lg, "xl": _xl, "2xl": _2xl }
export { config as default, _sm, _md, _lg, _xl, _2xl }